import { routesName, useGetAuthorityGetAccessById, useGetAuthorityGetRoleById, useNavigation } from "core";
import React,{ memo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Detail } from "../../../templates";

const MandantoryMembershipDetail = memo(() => {
  const {_navigateWithParams}=useNavigation()
  const { i18n } = useTranslation();
  const { id } = useParams();
  console.log(id,'id');
  
  const { data,isFetching } = useGetAuthorityGetAccessById({accessId :`${id}`});
  
  return (
    <>
      <Detail
        isLoading={isFetching}
        title={i18n.t("roleDetail")}
        data={data}
        onClick={() => {
          _navigateWithParams(routesName.EDITROLE, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { MandantoryMembershipDetail };
